<div class="main-frame-wrapper">
  <mat-drawer-container class="drawer-container">
    <mat-drawer #sidebarDrawer mode="side" position="end" class="sidebar-wrapper">
      <div class="sidebar-content">
        <div *ngIf="sidebarService.sidebarOpened == 1 && mapService.readyOpenLayersMap">
          <ebw-layers-configurator #ebwLayersConfig [config]="mapConfiguration.sceltaRappresentazione" (openLegend)="openLegendLayers()">
          </ebw-layers-configurator>
        </div>

        <div *ngIf="sidebarService.sidebarOpened == 5">
          <ebw-dynamic-layers></ebw-dynamic-layers>
        </div>
      </div>
      <div class="s-footer">
        <div class="separator">
          <mat-divider></mat-divider>
        </div>
        <div class="buttons">
          <button mat-flat-button color="primary" [matTooltip]="'common.close' | translate" (click)="closeSidebar()">
            {{ 'common.close' | translate }}
          </button>
        </div>
      </div>
    </mat-drawer>

    <div class="main-content">
      <div class="map-wrapper">
        <div class="streetview-frame" [ngClass]="{ 'half-screen': streetviewService.isActive, 'zero-screen': !streetviewService.isActive }">
          <ebw-google-streetview *ngIf="streetviewService.isActive"></ebw-google-streetview>
        </div>

        <div
          class="map-frame"
          #mapComponentFrame
          [ngClass]="{ 'half-screen': streetviewService.isActive, 'full-screen': !streetviewService.isActive }"
        >
          <!--This component has the map and all the custom map controls-->
          <ebw-map [mapConfiguration]="mapConfiguration" #mapSelector></ebw-map>

          <div class="back-button-container" *ngIf="mapService.showBackButton">
            <button (click)="onBackButtonClick()" color="primary" mat-raised-button>
              {{ 'map.map_component.go_back_to_research_page' | translate }}
            </button>
          </div>

          <div class="map-controls" *ngIf="!externalToolbar">
            <ng-container *ngTemplateOutlet="mapControls"></ng-container>
          </div>

          <!--Map Drawing tool-->
          <ebw-drawing-tool *ngIf="drawingToolService.drawingToolOpen" [options]="drawingToolService.drawingToolOptions"></ebw-drawing-tool>

          <!--Map Search-->
          <ebw-map-search
            *ngIf="
              mapLayout.googleSearch &&
              mapLayout.googleSearch.active &&
              ((!!mapConfiguration.google_key && (mapService.readyGoogleMapsMapChanged | async)) || mapService.readyOpenLayersMap) &&
              (!!mapConfiguration.google_key || mapConfiguration.searchSetup.modes.length > 0)
            "
            [config]="mapConfiguration.searchSetup"
            [isGoogleKeyEnabled]="!!mapConfiguration.google_key"
            class="search-positioning"
          >
          </ebw-map-search>

          <!-- PSA duplicate component -->
          <ebw-monorepo-psa-duplicate *ngIf="psaService.isVisibleDuplicatePsa"> </ebw-monorepo-psa-duplicate>
          <!-- PSA create interconnection -->
          <ebw-monorepo-psa-create-interconnection *ngIf="psaService.isVisibleCreateInterconnection"> </ebw-monorepo-psa-create-interconnection>

          <div class="map-info-preview" [ngClass]="{
            'map-info-preview-bottom-left': !mapConfiguration?.mapPreviewSetup?.position || mapConfiguration?.mapPreviewSetup?.position == 'bottomLeft',
            'map-info-preview-top-right': mapConfiguration?.mapPreviewSetup?.position == 'topRight'
          }">
            <ebw-map-preview
              *ngIf="
                mapLayout.mapPreview &&
                mapLayout.mapPreview.active &&
                ((!!mapConfiguration.google_key && (mapService.readyGoogleMapsMapChanged | async)) || mapService.readyOpenLayersMap)
              "
              [isGoogleKeyEnabled]="!!mapConfiguration.google_key"
              class="map-preview-wrapper d-none d-md-block"
              [previewZoomOverflow]="4"
            >
            </ebw-map-preview>

            <ebw-info-view
              *ngIf="mapLayout.infoView && mapLayout.infoView.active && mapService.readyOpenLayersMap"
              class="d-none d-md-block"
              [decimalPlaces]="6"
            >
            </ebw-info-view>
          </div>

          <div class="map-controls-container gap-2">
            <!-- Map Controls -->
            <ebw-world-layer-change
              *ngIf="mapLayout.worldLayerChange && mapLayout.worldLayerChange.active"
              [class.world-layer-change-positioning-right]="!externalToolbar"
            >
            </ebw-world-layer-change>
            <ebw-monorepo-map-control-speed-dial *ngIf="externalToolbar">
              <ng-container *ngTemplateOutlet="mapControls"></ng-container>
            </ebw-monorepo-map-control-speed-dial>
          </div>
        </div>
      </div>
    </div>
  </mat-drawer-container>
</div>

<ng-template #mapControls>
  <!--Base map controls-->
  <ebw-map-zoom-in #MapControl *ngIf="mapLayout.zoomControls && mapLayout.zoomControls.active"> </ebw-map-zoom-in>

  <ebw-map-zoom-out #MapControl *ngIf="mapLayout.zoomControls && mapLayout.zoomControls.active"> </ebw-map-zoom-out>

  <ebw-map-full-screen #MapControl *ngIf="mapLayout.fullScreenControl && mapLayout.fullScreenControl.active"> </ebw-map-full-screen>

  <ebw-map-go-to-position #MapControl *ngIf="mapLayout.goToPositionControl && mapLayout.goToPositionControl.active"> </ebw-map-go-to-position>

  <ebw-google-street-view
    #MapControl
    *ngIf="
      mapLayout.googleStreetView &&
      mapLayout.googleStreetView.active &&
      !!mapConfiguration.google_key &&
      (mapService.readyGoogleMapsMapChanged | async)
    "
  >
  </ebw-google-street-view>

  <ebw-print-map-control #MapControl *ngIf="canViewPrint"></ebw-print-map-control>

  <ebw-plot-map-control #MapControl *ngIf="canViewPlot"></ebw-plot-map-control>

  <ebw-dxf-map-control #MapControl *ngIf="canViewDXF"></ebw-dxf-map-control>
  <!--Base map controls-->

  <!--mini controls dropdown-->
  <div class="more-controls-positioning" #MapControl *ngIf="!externalToolbar">
    <button
      *ngIf="!expandedControls"
      mat-mini-fab
      class="mat-mini-fab-map-control"
      (click)="toggleControls()"
      [matTooltip]="'map.map_component.more_map_controls' | translate"
      matTooltipPosition="below"
      matTooltipShowDelay="1000"
    >
      <mat-icon>more_horiz</mat-icon>
    </button>

    <ng-container *ngIf="!externalToolbar">
      <button
        *ngIf="expandedControls"
        mat-mini-fab
        class="mat-mini-fab-map-control"
        (click)="toggleControls()"
        [matTooltip]="'common.close' | translate"
        matTooltipPosition="below"
        matTooltipShowDelay="1000"
      >
        <mat-icon>close</mat-icon>
      </button>

      <div class="more-controls-menu" [@openControlsMenu]="expandedControls ? 'open' : 'closed'">
        <div class="ms-1" *ngIf="mapLayout.layerSelection && mapLayout.layerSelection.active">
          <button
            mat-mini-fab
            class="mat-mini-fab-map-control"
            [matTooltip]="'map.map_component.layer_selection' | translate"
            matTooltipPosition="below"
            matTooltipShowDelay="1000"
            (click)="openLayerSelection()"
          >
            <mat-icon>layers</mat-icon>
          </button>
        </div>

        <div class="ms-1" *ngIf="mapLayout.drawingTool && mapLayout.drawingTool.active && mapService.readyOpenLayersMap">
          <button
            mat-mini-fab
            class="mat-mini-fab-map-control"
            [matTooltip]="'map.map_component.drawing_tool' | translate"
            matTooltipPosition="below"
            matTooltipShowDelay="1000"
            (click)="openDrawingTool()"
          >
            <mat-icon>shape_line</mat-icon>
          </button>
        </div>

        <div class="ms-1" *ngIf="mapLayout.dynamic_layers && mapLayout.dynamic_layers.active">
          <button
            mat-mini-fab
            class="mat-mini-fab-map-control"
            [matTooltip]="'map.map_component.additional_layers' | translate"
            matTooltipPosition="below"
            matTooltipShowDelay="1000"
            (click)="openDynamcLayers()"
          >
            <mat-icon>dynamic_feed</mat-icon>
          </button>
        </div>
      </div>
    </ng-container>
  </div>
</ng-template>
